import * as yup from "yup";

export const userProfileSchema = yup
  .object({
    first_name: yup.string().required("First name is required"),
    last_name: yup.string().required("Last name is required"),
    email: yup
      .string()
      .email("Invalid mail address")
      .required("Email is required"),
    team: yup.string(),
    isActive: yup.boolean().required("Is active is required"),
    worklogsRequired: yup.boolean().required("Worklogs is required"),
    isSuperAdmin: yup.boolean().required(),
  })
  .required();
